import { useMutation } from "@tanstack/react-query";
import { consolidationContract } from "@common/contracts/consolidation.contract";
import {
    ConsolidationGroupMemberResponse,
    UpdateConsolidationGroupMemberBody,
} from "@common/schemas/domains/accounting/consolidation.schema";
import { getBackendAPIClient } from "@lib/backendAPIClient";
import { queryClient } from "queryClient";
import { invalidateConsolidationGroupMutations } from "./consolidationCache.helpers";

const consolidationClient = getBackendAPIClient(consolidationContract);

interface UpdateGroupMemberVariables {
    groupId: string;
    memberId: string;
    body: UpdateConsolidationGroupMemberBody;
}

export function useUpdateGroupMemberMutation(workspaceId: string) {
    return useMutation({
        mutationFn: async ({
            groupId,
            memberId,
            body,
        }: UpdateGroupMemberVariables): Promise<ConsolidationGroupMemberResponse> => {
            const result = await consolidationClient.updateGroupMember({
                params: { workspaceId, id: groupId, memberId },
                body,
            });
            if (result.status !== 200) {
                throw result;
            }
            return result.body.member;
        },
        onSuccess: () => {
            invalidateConsolidationGroupMutations(queryClient);
        },
    });
}
